module.exports = __webpack_public_path__ + "static/assets/89e50383cc7c3075e61387b05a2689d3.svg";